import { BaseEntityDto } from '@fleet-beat/core';
import { VehicleParamsGroupEnum, VehicleParamsNameEnum } from './vehicle.dto';

export interface VehicleSocketParametersDto extends BaseEntityDto {
  group?: VehicleParamsGroupEnum;
  name?: VehicleParamsNameEnum;
  value?: string;
  metaData: {
    lat?: number;
    lon?: number;
    nearestPlace?: string;
  };
}

export interface VehicleParamsFormatted {
  [key: string]: VehicleParamData | TiresTelemetryParamData;
  fuelLevel: VehicleParamData;
  fuelRate: VehicleParamData;
  speed: VehicleParamData;
  rpm: VehicleParamData;
  engineTemp: VehicleParamData;
  oilTemp: VehicleParamData;
  oilPress: VehicleParamData;
  intakeTemp: VehicleParamData;
  inletTemp: VehicleParamData;
  engineLoad: VehicleParamData;
  voltage: VehicleParamData;
  throttle: VehicleParamData;
  maf: VehicleParamData;
  map: VehicleParamData;
  odometer: VehicleParamData;
  engineHours: VehicleParamData;
  tiresTelemetry: TiresTelemetryParamData;
}

export interface TiresTelemetryParamData {
  lastSync: string | null;
  tyreFrontLeftTemp: TireTempParamData;
  tyreFrontRightTemp: TireTempParamData;
  tyreFrontLeftPressure: TirePressureParamData;
  tyreFrontRightPressure: TirePressureParamData;
  tyreRearLeftOutsideTemp: TireTempParamData;
  tyreRearRightOutsideTemp: TireTempParamData;
  tyreRearLeftOutsidePressure: TirePressureParamData;
  tyreRearRightOutsidePressure: TirePressureParamData;
  tyreRearLeftInsideTemp: TireTempParamData;
  tyreRearRightInsideTemp: TireTempParamData;
  tyreRearLeftInsidePressure: TirePressureParamData;
  tyreRearRightInsidePressure: TirePressureParamData;
}

export interface TirePressureParamData {
  kPa: VehicleParamData;
  bar: VehicleParamData;
  psi: VehicleParamData;
}

export interface TireTempParamData {
  c: VehicleParamData;
  f: VehicleParamData;
}

export interface VehicleParamData {
  value?: number | null;
  max?: number;
  min?: number;
  warning?: number;
  normal?: number;
  warningLow?: number;
  dangerLow?: number;
  lastSync?: string | null;
}
